import { ReactComponent as EidLogoSvg } from './eid-logo.svg'
export default EidLogoSvg
